
<div class="searchable-dropdown" ref="dropdownContainer">
  <!-- Multi-select chips display -->
  <div v-if="mode === 'multi' && dropdown.selectedItems.length" class="selected-chips mb-2">
    <span 
      v-for="(item, index) in dropdown.selectedItems" 
      :key="index"
      class="badge badge-primary mr-1 mb-1">
      {{ dropdown.getItemText(item) }}
      <i class="fas fa-times ml-1" @click="() => dropdown.remove(item)" style="cursor: pointer;"></i>
    </span>
  </div>

  <!-- Search input -->
  <div class="position-relative">
    <input
      ref="searchInput"
      type="text"
      class="form-control form-control-sm"
      :placeholder="placeholder"
      v-model="dropdown.search"
      @input="() => dropdown.onInput()"
      @focus="() => dropdown.open()"
      @blur="() => dropdown.onBlur()"
      @keydown="(e) => dropdown.handleKeydown(e)"
      :aria-expanded="dropdown.isOpen"
      :aria-autocomplete="'list'"
      :disabled="disabled"
      role="combobox"
    />
    <i 
      v-if="dropdown.hasSelection && !disabled"
      class="fas fa-times clear-icon"
      @click="() => dropdown.clear()"
      title="Clear selection"
    ></i>
  </div>

  <!-- Dropdown list -->
  <div 
    v-show="dropdown.isOpen && dropdown.filteredItems.length"
    class="dropdown-list"
    role="listbox">
    <div
      v-for="(item, index) in dropdown.filteredItems"
      :key="index"
      class="dropdown-item"
      :class="{ 'selected': dropdown.isSelected(item) }"
      @click="() => dropdown.select(item)"
      :aria-selected="dropdown.isSelected(item)"
      role="option">
      <i v-if="mode === 'multi' && dropdown.isSelected(item)" class="fas fa-check mr-2"></i>
      {{ dropdown.getItemText(item) }}
    </div>
  </div>

  <!-- No results message -->
  <div 
    v-show="dropdown.isOpen && !dropdown.filteredItems.length && dropdown.search"
    class="dropdown-list no-results">
    <div class="dropdown-item disabled">No results found</div>
  </div>
</div>
